<div class="course-details">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div class="intro">
    <h2 class="mat-display-2">Details zum Kurs</h2>
  </div>
  <div class="details" *ngIf="course !== undefined">
    <div class="back-link">
      <a (click)="returnToArchive()" class="list">Zum Programm</a>
      <a *ngIf="isAdmin()" routerLink="/courses" class="list"
      >Zurück zur Kursliste
      </a>
    </div>
    <mat-card class="preview">
      <mat-card-header>
        <mat-card-title style="padding: 1rem 0; line-height: 2.5rem!important;">{{ course.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="properties">
          <div *ngIf="course.start_date">
            <p class="label">Wann:</p>
            <p class="value">
              {{ course.start_date | date }} - {{ course.end_date | date }}
            </p>
          </div>
          <div *ngIf="course.days">
            <p class="label">Kategorie:</p>
            <p class="value">
              {{ course.category_name }}
            </p>
          </div>
          <div *ngIf="course.days">
            <p class="label">Tage und Uhrzeit:</p>
            <p class="value">
              {{ course.days }}
            </p>
          </div>
          <div *ngIf="course.location">
            <p class="label">Wo:</p>
            <p class="value">{{ course.location }}</p>
          </div>
          <div *ngIf="course.course_fees">
            <p class="label">Kursgebühr:</p>
            <p class="value">{{ course.course_fees | currency : "EUR" }}</p>
          </div>
          <div *ngIf="course.duration">
            <p class="label">U-Std.:</p>
            <p class="value">{{ course.duration }}</p>
          </div>
          <div *ngIf="course.lead">
            <p class="label">Leitung:</p>
            <p class="value">{{ course.lead }}</p>
          </div>
          <div *ngIf="course.code">
            <p class="label">Kurs-Nr.:</p>
            <p class="value">{{ course.code }}</p>
          </div>
        </div>
        <div [innerHTML]="course.content" class="preview-content"></div>
      </mat-card-content>
      <ng-template [ngIf]="!_SelectedYear">
        <mat-card-actions align="end">
          <button mat-button (click)="inscription(course.id || 0)">
            Anmelden
          </button>
          <span class="spacer"></span>
          <button mat-button (click)="editCourse()" *ngIf="isAdmin()">
            Bearbeiten
          </button>
          <button mat-button (click)="deleteCourse(course)" *ngIf="isAdmin()">
            Löschen
          </button>
        </mat-card-actions>
      </ng-template>

    </mat-card>
  </div>
</div>
